import { Translatable, TransProp } from "@icc/shared/helpers";

/** Kolor */
export class Color {
    /** Identyfikator */
    id: number;
    /** Nazwa */
    @Translatable({ model: 'Colors' })
    name: string;
    /** Kod */
    code?: string;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod do indeksu zmapowany dla integracji (po przejściu przez funkcję mapującą) */
    indexNoMapped?: string;
    /** Kod do wydruków */
    printCode?: string;
    /** Wartość RGB */
    color?: string;
    /** Adres obrazu */
    colorImg?: string;
    /** Grupy do których należy kolor */
    colorGroups?: number[];
    /** Grupy kolorów do dopłat per system-element */
    colorGroupsSurcharge?: {
        [shutterTypeIdElement: string]: number[];
    };
    /** Grupy kolorów prowadnic, dla których dopłata za prowadnicę ma być pominięta (per system-element) */
    skipGuideSurchargeForGroups?: {
        [shutterTypeIdElement: string]: number[];
    };
    /** Kolor bazy */
    isCore?: boolean;
    /** Typ koloru */
    type?: 'standard' | 'white' | 'grooved';

    visualization?: {
        visualizationColor: string;
        visualizationImage: string;
        visualizationOrientation: 'vertical' | 'horizontal';
        visualizationPositionX: 'left' | 'center' | 'right';
        visualizationPositionY: 'top' | 'center' | 'bottom';
        visualizationWidthMM: number;
        visualizationHeightMM: number;
    };
    /** Czy kolor został ustawiony automatycznie */
    isDefault?: boolean;
}

export type ColoredElement =
    | 'profile'
    | 'endRail'
    | 'guidance'
    | 'cover'
    | 'coverOutside'
    | 'coverInside'
    | 'inspectionHatch'
    | 'rollerBoxAdapter'
    | 'plasterStrip'
    | 'outerPlasterStrip'
    | 'innerPlasterStrip'
    | 'guideCap'
    | 'guideOverlay'
    | 'profileGuideChannelCap'
    | 'mosquitoGuideChannelCap'
    | 'rolledMosquitoNet'
    | 'pleatedMosquitoNet'
    | 'mosquitoEndRail'
    | 'mosquitoProfile'
    | 'endRailBuffer'
    | 'blindSide'
    | 'rollerGuideSpacerStrip';

export class ColorsConfig {
    /** Kolor płaszcza (pancerza) */
    @TransProp()
    profile?: Color;
    /** Kolor listwy dolnej rolety */
    @TransProp()
    endRail?: Color;
    /** Kolor prowadnic */
    @TransProp()
    guidance?: Color;
    /** Kolor skrzynki */
    @TransProp()
    cover?: Color;
    /** Kolor skrzynki zewnątrz */
    @TransProp()
    coverOutside?: Color;
    /** Kolor skrzynki wewnątrz */
    @TransProp()
    coverInside?: Color;

    /** Kolor klapy rewizyjnej */
    @TransProp()
    inspectionHatch?: Color;
    /** Kolor trawersy (adaptera) */
    @TransProp()
    rollerBoxAdapter?: Color;
    /** Kolor listwy tynkowej */
    @TransProp()
    plasterStrip?: Color;
    /** Kolor listwy tynkowej zewnętrznej */
    @TransProp()
    outerPlasterStrip?: Color;
    /** Kolor listwy tynkowej wewnętrznej */
    @TransProp()
    innerPlasterStrip?: Color;
    /** Kolory zaślepek/zatyczek dolnych prowadnic */
    @TransProp(Color)
    guideCaps?: Record<number, {
        left: Color,
        right: Color
    }>;

    /** Kolor nakładek na prowadnice */
    @TransProp()
    guideOverlay?: Color;
    /** Kolor zaślepki kanału prowadnicy pancerza */
    @TransProp()
    profileGuideChannelCap?: Color;
    /** Kolor zaślepki kanału prowadnicy moskitiery */
    @TransProp()
    mosquitoGuideChannelCap?: Color;
    /** Kolor siatki moskitiery rolowanej */
    @TransProp()
    rolledMosquitoNet?: Color;
    /** Kolor siatki moskitiery plisowanej */
    @TransProp()
    pleatedMosquitoNet?: Color;
    /** Kolor listwy dolnej moskitiery */
    @TransProp()
    mosquitoEndRail?: Color;
    /** Kolor profilu moskitiery */
    @TransProp()
    mosquitoProfile?: Color;

    /** Kolor buforu listwy dolnej */
    @TransProp()
    endRailBuffer?: Color;

    /** Kolor boku skrzynki */
    @TransProp()
    blindSide?: Color;

    /** Kolor listwy dystansowej prowadnicy */
    @TransProp()
    rollerGuideSpacerStrip?: Color;

    /** Dopasowanie kolorów do profilu */
    matchToProfile: boolean;
}
